import {useAtomValue} from 'jotai';
import {useEffect} from 'react';
import {mobileAnalysisPointAtom} from '@/map/atom';
import {MAX_VISIBLE_ZOOM_METER} from '@/map/constants';
import {useVisibleZoomLevel} from '@/map/hooks';
import {Circle, panToBoundCircle} from '@/map/modules';
import {palette} from '@/styles';
import {AnalysisCenterMarker} from '../Marker';

interface IProps {
  map?: naver.maps.Map;
}

export const MarkerCluster = ({map}: IProps) => {
  const analysisPoint = useAtomValue(mobileAnalysisPointAtom);
  const isVisibleZoom = useVisibleZoomLevel(
    MAX_VISIBLE_ZOOM_METER.mobile_markers
  );

  useEffect(() => {
    if (analysisPoint && map) {
      panToBoundCircle(
        {
          center: analysisPoint.center,
          radius: analysisPoint.radius,
        },
        map,
        {
          top: 60,
          bottom: 211,
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [analysisPoint]);

  if (!map || !analysisPoint?.center || !analysisPoint.radius) {
    return null;
  }

  return (
    <>
      <AnalysisCenterMarker map={map} position={analysisPoint.center} />
      {isVisibleZoom && (
        <Circle
          map={map}
          radius={analysisPoint.radius}
          center={analysisPoint.center}
          strokeColor={palette.teal100}
          fillColor={palette.teal100}
          fillOpacity={0.05}
          strokeStyle="dash"
        />
      )}
    </>
  );
};
